module.exports = __webpack_public_path__ + "img/smsCost.a65988f9.png";